import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "contDetailViewBlock" }
const _hoisted_3 = { class: "contDetailViewBlock" }
const _hoisted_4 = { class: "contDetailViewBlock" }
const _hoisted_5 = { class: "contDetailViewBlock" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "contDetailViewBlock" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "contDetailViewBlock" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "contDetailViewBlock" }
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "selectListBoxLayer contDetailViewSelect left",
    style: _normalizeStyle({top : $props.top+'px', left : $props.left+'px'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[15] || (_cache[15] = _createTextVNode(" 연락처 상세 조건 ", -1)),
      _createElementVNode("button", {
        class: "right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clear_value()))
      }, "선택 초기화")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "subTitle" }, "대상자 구분", -1)),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: 0,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.ui.blar) = $event))
        }, null, 512), [
          [_vModelRadio, $data.ui.blar]
        ]),
        _cache[16] || (_cache[16] = _createTextVNode("전체", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: 1,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.ui.blar) = $event))
        }, null, 512), [
          [_vModelRadio, $data.ui.blar]
        ]),
        _cache[17] || (_cache[17] = _createTextVNode("상생방송", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: 4,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.ui.blar) = $event))
        }, null, 512), [
          [_vModelRadio, $data.ui.blar]
        ]),
        _cache[18] || (_cache[18] = _createTextVNode("역사광복", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: 9,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.ui.blar) = $event))
        }, null, 512), [
          [_vModelRadio, $data.ui.blar]
        ]),
        _cache[19] || (_cache[19] = _createTextVNode("미지정", -1))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "subTitle" }, "상생방송", -1)),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          value: 1,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.ui.blar_cate_cd) = $event))
        }, null, 512), [
          [_vModelCheckbox, $data.ui.blar_cate_cd]
        ]),
        _cache[21] || (_cache[21] = _createTextVNode(" 적극시청", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          value: 2,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.ui.blar_cate_cd) = $event))
        }, null, 512), [
          [_vModelCheckbox, $data.ui.blar_cate_cd]
        ]),
        _cache[22] || (_cache[22] = _createTextVNode(" 가끔시청", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          value: 3,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.ui.blar_cate_cd) = $event))
        }, null, 512), [
          [_vModelCheckbox, $data.ui.blar_cate_cd]
        ]),
        _cache[23] || (_cache[23] = _createTextVNode(" 시청안함", -1))
      ])
    ], 512), [
      [_vShow, $data.ui.blar =='1']
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "subTitle" }, "성별", -1)),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          value: 1,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.ui.sex) = $event))
        }, null, 512), [
          [_vModelCheckbox, $data.ui.sex]
        ]),
        _cache[25] || (_cache[25] = _createTextVNode(" 남자", -1))
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          value: 0,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.ui.sex) = $event))
        }, null, 512), [
          [_vModelCheckbox, $data.ui.sex]
        ]),
        _cache[26] || (_cache[26] = _createTextVNode(" 여자", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "subTitle" }, "등급", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code_list.filter(x => x.CATE_KEY == 'RTNG_CD'), (r) => {
        return (_openBlock(), _createElementBlock("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: r.CODE,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.ui.rtng) = $event))
          }, null, 8, _hoisted_6), [
            [_vModelCheckbox, $data.ui.rtng]
          ]),
          _createTextVNode(" " + _toDisplayString(r.CODE_NM), 1)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "subTitle" }, "유형", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code_list.filter(x => x.CATE_KEY == 'BLVR_RELA_CD'), (r) => {
        return (_openBlock(), _createElementBlock("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: r.CODE,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.ui.rela) = $event))
          }, null, 8, _hoisted_8), [
            [_vModelCheckbox, $data.ui.rela]
          ]),
          _createTextVNode(_toDisplayString(r.CODE_NM), 1)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "subTitle" }, "지역", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code_list.filter(x => x.CATE_KEY == 'REGI_CD'), (r) => {
        return (_openBlock(), _createElementBlock("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: r.CODE,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.ui.regi) = $event))
          }, null, 8, _hoisted_10), [
            [_vModelCheckbox, $data.ui.regi]
          ]),
          _createTextVNode(_toDisplayString(r.CODE_NM), 1)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "subTitle" }, "도서", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.book_list, (r) => {
        return (_openBlock(), _createElementBlock("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: r.BOOK_NO,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.ui.book_nos) = $event))
          }, null, 8, _hoisted_12), [
            [_vModelCheckbox, $data.ui.book_nos]
          ]),
          _createTextVNode(_toDisplayString(r.TITLE), 1)
        ]))
      }), 256))
    ]),
    _createElementVNode("button", {
      class: "selectListBoxLayerFinBtn2",
      onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.CustSelectFilter()))
    }, "선택 완료")
  ], 4)), [
    [_vShow, $data.is_view]
  ])
}